/*
 * @Author: zhou lei
 * @Date: 2020-08-24 09:11:30
 * @LastEditTime: 2024-01-18 17:08:28
 * @LastEditors: zhou lei
 * @Description:
 * @FilePath: /mmeui/src/i18n/index.js
 * 联系方式:910592680@qq.com 18669792120 科海达信息技术有限公司
 */
import zh from './zh'
import en from './en'
import elementEnLocale from 'element-ui/lib/locale/lang/en' // element-ui 英文包
import elementZhLocale from 'element-ui/lib/locale/lang/zh-CN' // element-ui 中文包
const messages = {
  en: {
    ...en,
    ...elementEnLocale
  },
  // 中文环境下的语言数据
  zh: {
    ...zh,
    ...elementZhLocale
  }
}
export default messages
